import { useEnterpriseOrgSettings } from 'src/api/queries/enterpriseAdmin';
import { useAccessTokenClaims } from 'src/api/queries/user';
import { Feedback } from 'src/components';
import { AppPage } from 'src/components/AppPage';
import { StartEnterpriseDomainForwardingNotification } from 'src/components/StartEnterpriseDomainForwardingNotification';
import { StartEnterpriseMigrationNotifiaction } from 'src/components/StartEnterpriseMigrationNotification';
import { TestId } from 'src/testids';
import { enterpriseHelpers } from 'src/utils/enterpriseHelpers';
import { userHelpers } from 'src/utils/userHelpers';
import { DomainsTable } from '../components/DomainsTable';

export function EnterPriseDomainsPage() {
  const accessTokenClaims = useAccessTokenClaims();
  const orgSettings = useEnterpriseOrgSettings();
  const primaryDomain = enterpriseHelpers.getPrimaryDomain(orgSettings.data);

  const canUpdateOrgSettings =
    accessTokenClaims.data &&
    userHelpers.hasPermissionUpdateOrgSettings(accessTokenClaims.data);

  const canStartMigration =
    canUpdateOrgSettings &&
    !enterpriseHelpers.isMigrationEnabled(primaryDomain) &&
    !enterpriseHelpers.isDomainForwardingEnabled(primaryDomain);

  const canStartDomainForwarding =
    canUpdateOrgSettings &&
    enterpriseHelpers.isMigrationEnabled(primaryDomain) &&
    !enterpriseHelpers.isDomainForwardingEnabled(primaryDomain);
  return (
    <>
      <AppPage.Header
        className="w-full justify-start px-16 text-left lm:px-32"
        title="Domains"
      />
      <AppPage.Content
        className="max-w-l2xl"
        data-cy={TestId.PageEnterpriseDomains}
      >
        <div className="flex flex-col gap-32">
          {canStartMigration && <StartEnterpriseMigrationNotifiaction />}

          {canStartDomainForwarding && (
            <StartEnterpriseDomainForwardingNotification />
          )}

          <DomainsTable />
        </div>
        <Feedback
          feedbackTargetId="enterprise-domains-page"
          title="Did you find what you were looking for?"
        />
      </AppPage.Content>
    </>
  );
}
